import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import styles from "./countrySelect.style";
import { ucFirst } from "Services/utils/index";
import Flag from "react-world-flags";

const RegionMarkets = props => {
    const { classes } = props;

    return (
        <Grid container direction="row" className={classes.regionCountries}>
            {props.regionMarkets
                .sort((a, b) => {
                    var nameA = a.country.toLowerCase(),
                        nameB = b.country.toLowerCase();
                    if (nameA < nameB)
                        //sort string ascending
                        return -1;
                    if (nameA > nameB) return 1;
                    return 0; //default return value (no sorting)
                })
                .map(market => (
                    <Grid item xs={12} sm={6} md={3} key={market.countryCode}>
                        <div className={classes.countryBox}>
                            <div className={classes.flagBox}>
                                <Flag
                                    code={market.countryCode}
                                    style={{ cursor: "pointer", height: "16px" }}
                                    onClick={() => props.countryChange(market.countryCode)}
                                />
                            </div>
                            <div>
                                <div
                                    onClick={() => props.countryChange(market.countryCode)}
                                    className={classes.countryName}
                                    data-testid="market_name"
                                >
                                    {ucFirst(market.country)}
                                </div>
                                <div className={classes.countryLang}>
                                    {market.languages.map((lang, index) => {
                                        return (
                                            <div key={lang.name} style={{ float: "left" }}>
                                                <span
                                                    onClick={() => props.langCountryChange(market.countryCode, lang.code)}
                                                    className={classes.lang}
                                                    data-testid="market_language"
                                                >
                                                    {lang.name}
                                                </span>
                                                {index + 1 !== market.languages.length && (
                                                    <span className={classes.langDivider}></span>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </Grid>
                ))}
        </Grid>
    );
};

export default withStyles(styles)(RegionMarkets);



// WEBPACK FOOTER //
// ./src/components/StartContainer/CountrySelect/RegionMarkets.js